import "./MenuDesignSelector.scss"

import { useState, useMemo, useRef, useCallback, useEffect } from "react"

import DefaultBoundaries from "@/app/boundaries/DefaultBoundaries"
import { MenuAppInstance } from "@/entities/app/menu/menu.types"
import { Design } from "@/entities/design"
import Field from "@/shared/components/intrinsic/Field/Field"
import { inputValue } from "@/utils/common"

import MenuDesignPreviewsContainer from "../MenuDesignPreviews/MenuDesignPreviewsContainer"




export interface MenuDesignSelectorProps {
  app: MenuAppInstance

  current?: Design | null
  onChange?(design: Design): void | Promise<void>
  onRefreshReady?(refreshFn: () => Promise<void>): void
}

function MenuDesignSelector(props: MenuDesignSelectorProps) {
  const [name, setName] = useState("")
  const refetchRef = useRef<(() => Promise<any>) | null>(null)

  const filters = useMemo(() => ({ name: name.trim() }), [name])

  const handleRefetchUpdate = useCallback((refetch: () => Promise<any>) => {
    refetchRef.current = refetch
  }, [])

  const handleRefresh = useCallback(async () => {
    setName("")
    if (refetchRef.current) {
      await refetchRef.current()
    }
  }, [])

  // Expose refresh function to parent component
  useEffect(() => {
    if (props.onRefreshReady) {
      props.onRefreshReady(handleRefresh)
    }
  }, [handleRefresh, props.onRefreshReady])

  return (
    <div className="menu-design-selector">
      <Field placeholder="Search for designs..." value={name} onChange={inputValue(setName)} />
      <DefaultBoundaries>
        <MenuDesignPreviewsContainer
          app={props.app}
          filters={filters}
          selected={props.current}
          onSelect={props.onChange}
          onRefetch={handleRefetchUpdate}
        />
      </DefaultBoundaries>
    </div>
  )
}

export default MenuDesignSelector
